import { gql } from "@apollo/client";
import { CORE_MISSION_ROLE_TEMPLATE_FIELDS } from "graphql/fragments";

const ADD_MISSION_ROLE_TEMPLATE = gql`
  ${CORE_MISSION_ROLE_TEMPLATE_FIELDS}
  mutation AddMissionRoleTemplate($input: AddMissionRoleTemplateInput!) {
    addMissionRoleTemplate(input: $input) {
      missionRoleTemplate {
        ...MissionRoleTemplateFields
      }
    }
  }
`;

const UPDATE_MISSION_ROLE_TEMPLATE = gql`
  ${CORE_MISSION_ROLE_TEMPLATE_FIELDS}
  mutation UpdateMissionRoleTemplate($input: UpdateMissionRoleTemplateInput!) {
    updateMissionRoleTemplate(input: $input) {
      missionRoleTemplate {
        ...MissionRoleTemplateFields
      }
    }
  }
`;

const REMOVE_MISSION_ROLE_TEMPLATE = gql`
  mutation RemoveMissionRoleTemplate($input: RemoveMissionRoleTemplateInput!) {
    removeMissionRoleTemplate(input: $input) {
      id
    }
  }
`;

const GENERATE_MISSION_ROLE_TEMPLATE = gql`
  ${CORE_MISSION_ROLE_TEMPLATE_FIELDS}
  mutation GenerateMissionRoleTemplate($input: GenerateMissionRoleTemplateInput!) {
    generateMissionRoleTemplate(input: $input) {
      missionRoleTemplate {
        ...MissionRoleTemplateFields
      }
    }
  }
`;

export {
  ADD_MISSION_ROLE_TEMPLATE,
  UPDATE_MISSION_ROLE_TEMPLATE,
  REMOVE_MISSION_ROLE_TEMPLATE,
  GENERATE_MISSION_ROLE_TEMPLATE,
};
